module.exports = __webpack_public_path__ + "img/cyurica_icon.b3350405.jpg";